import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import VueClipboard from 'vue-clipboard2';
import axios from 'axios';



Vue.config.productionTip = false

axios.interceptors.response.use(response => {
  
  return response;
}, error => {
 
  // if (error.response && error.response.status === 404) {
  //   router.push('/error/404'); 
  // }
  if (error.response) {
    const requestedUrl = error.config.url;
   
    if (requestedUrl.includes('/auth/login') && error.response.status === 401) {
        return Promise.reject(error);
    }
    switch (error.response.status) {
      case 404:
        router.push('/error/404');
        break;
      case 401:
        router.push('/error/401_session');
        break;

    }
  }
  return Promise.reject(error);
});

Vue.use(VueClipboard);

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  mounted() {
    this.$store.dispatch('language/changeLanguage', this.$store.state.language.selectedLanguage)
      .catch(error => {
        console.error('error', error);
      });
  }
}).$mount('#app')


